import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Desktop section heading: large display title, sub-line, right-aligned action. */
@Component({
  selector: 'app-desk-head',
  standalone: true,
  imports: [NgIf, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    :host { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 20px; }
    h2 { margin: 0; font-family: var(--brand-display); font-weight: 750; letter-spacing: -0.02em; color: var(--fr-text); line-height: 1.1; }
    p { margin: 7px 0 0; font-size: 14.5px; color: var(--fr-text-3); }
    button { background: none; border: none; cursor: pointer; color: var(--brand-deep); font-weight: 750; font-size: 14.5px;
      font-family: var(--fr-font); display: flex; align-items: center; gap: 5px; flex-shrink: 0; white-space: nowrap; padding: 0 0 4px; }
  `],
  template: `<div>
      <h2 [style.font-size.px]="size">{{ title | t }}</h2>
      <p *ngIf="sub">{{ sub | t }}</p>
    </div>
    <button *ngIf="action" (click)="act.emit()">{{ action | t }} <app-icon name="solar:alt-arrow-right-linear" [size]="15"></app-icon></button>`,
})
export class DeskHeadComponent {
  @Input() title = '';
  @Input() sub?: string;
  @Input() action?: string;
  @Input() size = 30;
  @Output() act = new EventEmitter<void>();
}
